import styled, { css } from 'styled-components';
import { FloatingContainerProps } from 'layout/floating-container/floating-container.props';
import { getThemeSpacing, legacyTheme } from 'styles/theme';

export const StyledFloatingContainer = styled.div<FloatingContainerProps>`
  ${({ bottom, left, right, top }) => css`
    position: absolute;
    top: ${top ? getThemeSpacing(top) : 'unset'};
    right: ${right ? getThemeSpacing(right) : 'unset'};
    bottom: ${bottom ? getThemeSpacing(bottom) : 'unset'};
    left: ${left ? getThemeSpacing(left) : 'unset'};
  `}
`;
